import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as IndeedIcon } from './indeed.svg';

export const Indeed = IconHOC(IndeedIcon);
